module.exports = require("./fr-RE.js");